let onStudentAuthInvalid = null;
let onAffiliateAuthInvalid = null;

export function registerAuthInvalidHandlers(handlers) {
  onStudentAuthInvalid = handlers?.student ?? null;
  onAffiliateAuthInvalid = handlers?.affiliate ?? null;
}

export function clearStudentAuth() {
  localStorage.removeItem("token");
  onStudentAuthInvalid?.();
}

export function clearAffiliateAuth() {
  localStorage.removeItem("affiliatetoken");
  onAffiliateAuthInvalid?.();
}

export function normalizeStoredToken(value) {
  if (value == null || value === "" || value === "undefined" || value === "null") {
    return null;
  }
  return value;
}
